const FORM = "/form";
const LOGIN = "/login";
const ERROR = "/error";
const HISTORY = "/history";
const HCP = "/hcp";
const AFFILIATE = "/affiliate";

export const ROUTES = {
  FORM,
  LOGIN,
  ERROR,
  HISTORY,
  HCP,
  AFFILIATE,
};
